// Should be replaced with Vue i18n or something similar

export default function getPhrase(key, fillables = {}) {
  if (key in phrases) {
    let phrase = phrases[key]

    // Replace placeholders marked with {{double curly braces}}
    Object.keys(fillables).forEach((keyword) => {
      const placeholder = `{{${keyword}}}`
      phrase = phrase.replace(new RegExp(placeholder, "g"), fillables[keyword])
    })

    return phrase
  } else {
    return key
  }
}

const phrases = {
  "status-unknown": "Installatie status onbekend",
  "status-offline": "Installatie is offline",
  "status-online": "Installatie is online",
  "status-active-steering-curtailment": "Installatie wordt gecurtaild",
  "status-active-steering-charging": "Installatie is aan het opladen",
  "status-active-steering-discharging": "Installatie is aan het ontladen",
  "status-active-steering-not-specified": "Installatie wordt aangestuurd",
  "status-error": "Er is een fout opgetreden",

  "demo-disclaimer":
    "De getoonde resultaten zijn gebaseerd op simulaties met historische data om de services van Repowered te demonstreren.",

  "no-measurements-available":
    "Er zijn geen meetgegevens beschikbaar voor installaties met het type '{{type}}'.",

  "cannot-load-invoice-settings":
    "Er is een fout opgetreden bij het laden van de facturatie gegevens. Probeer het later opnieuw.",
  "cannot-view-invoice-settings":
    "Je hebt geen toegang tot de facturatie gegevens van dit portfolio. Neem contact op met de beheerder van dit portfolio om toegang te krijgen.",
  "cannot-edit-invoice-settings":
    "Je hebt geen toestemming om de facturatie gegevens van dit portfolio te wijzigen. Neem contact op met de beheerder van dit portfolio om toegang te krijgen.",

  "toast-breakpoint-limit":
    "Data van vóór 2025 kan niet tegelijk met nieuwe data worden getoond i.v.m. verschillende systemen. Maak een nieuwe selectie in een van beide periodes om meer resultaten te zien.",
  "toast-breakpoint-asset":
    "Resultaten op installatieniveau zijn niet beschikbaar vóór 2025. Kies een hoger niveau om meer resultaten te zien.",
}
